"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseRelativeUrl = parseRelativeUrl;
var _utils = require("../../utils");
var _querystring = require("./querystring");
function parseRelativeUrl(url, base) {
    var globalBase = new URL("object" === 'undefined' ? 'http://n' : (0, _utils).getLocationOrigin());
    var resolvedBase = base ? new URL(base, globalBase) : globalBase;
    var ref = new URL(url, resolvedBase), pathname = ref.pathname, searchParams = ref.searchParams, search = ref.search, hash = ref.hash, href = ref.href, origin = ref.origin;
    if (origin !== globalBase.origin) {
        throw new Error("invariant: invalid relative URL, router received ".concat(url));
    }
    return {
        pathname: pathname,
        query: (0, _querystring).searchParamsToUrlQuery(searchParams),
        search: search,
        hash: hash,
        href: href.slice(globalBase.origin.length)
    };
} //# sourceMappingURL=parse-relative-url.js.map
